import Http from '@/api/http.js'

export default {

  index(filters){
    return Http.get(`/internal_payments`, {params: {...filters}})
  },
  
  indexPrint(filter){
    return Http.get(`/print_drivers`, {
      params: {
        ...filter
      }
    });
  },

  show(id) {
    return Http.get(`/internal_payments/${id}`);
  },

  create(internal_payment) {
    return Http.post(`/internal_payments`, {internal_payment: {...internal_payment}})
  },
  createWithDriverId(internal_payment, driver_id){
    return Http.post(`/internal_payments`, {
      internal_payment:{
        ...internal_payment
      },
      driver_id
    })
  },

  update(internal_payment) {
    return Http.put(`/internal_payments/${internal_payment.id}`, {internal_payment: {...internal_payment}})
  },

  updateWithFormData(internal_payment){
    return Http.put(`/internal_payments/${internal_payment.get('internal_payment[id]')}`, internal_payment);
  },
}